// Auto-generated file

import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  "email-identifier-challenge": lazy(() => import("@/screens/email-identifier-challenge")),
  "login-id": lazy(() => import("@/screens/login-id")),
  "login-password": lazy(() => import("@/screens/login-password")),
  "mfa-country-codes": lazy(() => import("@/screens/mfa-country-codes")),
  "mfa-enroll-result": lazy(() => import("@/screens/mfa-enroll-result")),
  "mfa-login-options": lazy(() => import("@/screens/mfa-login-options")),
  "mfa-otp-challenge": lazy(() => import("@/screens/mfa-otp-challenge")),
  "mfa-otp-enrollment-code": lazy(() => import("@/screens/mfa-otp-enrollment-code")),
  "mfa-otp-enrollment-qr": lazy(() => import("@/screens/mfa-otp-enrollment-qr")),
  "mfa-recovery-code-challenge": lazy(() => import("@/screens/mfa-recovery-code-challenge")),
  "mfa-recovery-code-enrollment": lazy(() => import("@/screens/mfa-recovery-code-enrollment")),
  "mfa-sms-challenge": lazy(() => import("@/screens/mfa-sms-challenge")),
  "mfa-sms-enrollment": lazy(() => import("@/screens/mfa-sms-enrollment")),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-error": lazy(() => import("@/screens/reset-password-error")),
  "reset-password-request": lazy(() => import("@/screens/reset-password-request")),
  "reset-password-success": lazy(() => import("@/screens/reset-password-success")),
  "signup-id": lazy(() => import("@/screens/signup-id")),
  "signup-password": lazy(() => import("@/screens/signup-password")),
};

export const getScreenComponent = (screenName: string | undefined): React.ComponentType | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
